import { Outlet } from 'react-router-dom';
import Header from './Header/Header';
import Sidebar from './Sidebar/Sidebar';
import { SidebarProvider } from './Sidebar/SidebarContext';
import ReleaseBanner from '@/shared/components/ReleaseBanner/ReleaseBanner';

/**
 * AppLayout provides the main application shell:
 * - Sticky header with auth controls
 * - Collapsible sidebar navigation
 * - Main content area with <Outlet /> for nested routes
 */
export default function AppLayout() {
  return (
    <SidebarProvider>
      <div className="h-screen flex flex-col overflow-hidden">
        <Header />
        <ReleaseBanner />
        <div className="flex flex-1 min-h-0">
          <Sidebar />
          <main className="flex-1 overflow-y-auto p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
